"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    var PopupDefaults = {
        SelectActionCommandBindings: "{}",
        SelectionCompleted: null,
    };
    $dyn.ui.defaults.Popup = PopupDefaults;
    var controls;
    (function (controls) {
        /**
         * Framework base class for Popup form controls
         * @internal
         */
        var Popup = /** @class */ (function (_super) {
            __extends(Popup, _super);
            function Popup(data, element, parent, role) {
                var _this = _super.call(this, data, element, parent, role) || this;
                $dyn.ui.applyDefaults(_this, data, $dyn.ui.defaults.Popup);
                // Cannot cast Shell to Form
                _this.Root = $dyn.context($dyn.shell.getActiveForm()) || $dyn.shell;
                _this.RequestOpen = function (defaultVisibility) { };
                return _this;
            }
            Popup.prototype.IgnoreBlockingDiv = function (commandName) {
                return commandName === this.RequestCloseCommandName && this.highlyResponsive;
            };
            Popup.prototype.isActivePopup = function () {
                var activeForm = $dyn.shell.getActiveForm();
                var activeFormContext = $dyn.context(activeForm);
                return (activeForm === this.element || $dyn.shell.isFormRootOfNonFocusableActiveForm(this, activeFormContext) || (activeFormContext && this.Root && activeFormContext.Id === this.Root.Id));
            };
            Popup.prototype.Open = function () {
                if (this.onPopupReceived) {
                    // In "wait" scenarios the popup will come back from the server before, e.g., the RequestPopup interaction has finished. Therefore, any
                    // callbacks registered with the interaction system won't be called. To avoid this issue maintain an event on the popup that will be called
                    // when the popup is loaded, thus providing a guaranteed load hook.
                    this.onPopupReceived(this._createOnPopupReceivedEvent());
                }
                if ($dyn.value(this.ReadyState) !== $dyn.ui.ReadyState.aborted && (this.isActivePopup() || $dyn.shell === this.Root)) {
                    if (this.takeFocusOnOpen) {
                        $dyn.shell.activateElement(this.element, { forceActivation: true });
                    }
                    this.IsOpen(true);
                }
                else {
                    // Another root form was opened before we could open this popup or its opening was aborted.
                    this.popupAborted = true;
                    $dyn.applyFunction(this.Close, this);
                }
                if (!this._takeFocus && !this._focusModeToggler_FocusEventTarget) {
                    this._registerTakeFocusTransitioner();
                }
                // We want to apply size to available if lookup has only grid as control
                if ($dyn.shell.isPhone && this.Children) {
                    var children_1 = this.Children();
                    // Every form has FilterPane and FilterManager, so we are checking if List , FilterPane and FilterManager are the only children of form
                    if (children_1.length === 3 &&
                        children_1[0] &&
                        children_1[0].TypeName === "List" &&
                        children_1[1] &&
                        children_1[1].TypeName === "FilterPane" &&
                        children_1[2] &&
                        children_1[2].TypeName === "FilterManager") {
                        $dyn.setValue(children_1[0], "LayoutHeight", $dyn.layout.Size.available);
                        $dyn.setValue(children_1[0], "VisibleRowCount", 0);
                    }
                }
            };
            Popup.prototype.dispose = function () {
                if (this._focusModeToggler_FocusEventTarget) {
                    if (this._focusModeToggler_TargetMousedownEvent) {
                        this._focusModeToggler_FocusEventTarget.removeEventListener("mousedown", this._focusModeToggler_TargetMousedownEvent, true);
                        this._focusModeToggler_TargetMousedownEvent = null;
                    }
                    if (this._focusModeToggler_TargetClickEvent) {
                        this._focusModeToggler_FocusEventTarget.removeEventListener("click", this._focusModeToggler_TargetClickEvent, false);
                        this._focusModeToggler_TargetClickEvent = null;
                    }
                }
                if (this.element && this._focusModeToggler_FlyoutMouseDownEvent) {
                    this.element.removeEventListener("mousedown", this._focusModeToggler_FlyoutMouseDownEvent, true);
                    this._focusModeToggler_FlyoutMouseDownEvent = null;
                }
                _super.prototype.dispose.call(this);
            };
            Popup.prototype.shouldResetFocusOnClose = function () {
                var shouldResetFocus = true;
                if (this.element && !$dyn.value(this.TakeFocus)) {
                    // If the lookup form is set to not take focus, don't affect focus if the active element is not contained by the flyout.
                    shouldResetFocus = this.isElementContainedByPopup(document.activeElement);
                }
                return shouldResetFocus;
            };
            Popup.prototype.callRequestClose = function (requestCloseCallback, record) {
                var _this = this;
                var forceClose = $dyn.value(this.ReadyState) === $dyn.ui.ReadyState.aborted || this.highlyResponsive;
                if (this._isCloseRequested) {
                    if ($dyn.log.popups) {
                        $dyn.log.popups("Popups: Skipping attempt to call RequestClose for popup %s; It is already in the process of being closed.", this.Name ? this.Name : "<unknown>");
                    }
                }
                else {
                    this._isCloseRequested = true;
                    $dyn.log.popups && $dyn.log.popups("Popups: Calling RequestClose for popup %s.", this.Name ? this.Name : "<unknown>");
                    if (this.highlyResponsive) {
                        // Form close is forced; deactivate the popup immediately so that the UI feels responsive.
                        $dyn.shell.deactivateElement(this.element);
                        if (!this.popupAborted) {
                            // If popup was aborted it was never set as the active form
                            $dyn.shell.tryActivateParentElement(this, { takeNavigationFocus: this.shouldResetFocusOnClose() });
                        }
                    }
                    var paramRequestClose_1 = [forceClose];
                    // record is false or undefined
                    if (record === false) {
                        // To avoid recording pass true to the server.
                        paramRequestClose_1.push(true);
                    }
                    if ($dyn.serverForm && $dyn.peek($dyn.serverForm.processingInteractions)) {
                        // Subscribe to $dyn.serverForm.processingInteractions to avoid queuing close request when another request is proccessed
                        var subscriberId_1 = $dyn.serverForm.processingInteractions.valueChanged.subscribe(function () {
                            $dyn.callFunction(_this.RequestClose, _this, paramRequestClose_1, requestCloseCallback);
                            $dyn.serverForm.processingInteractions.valueChanged.unsubscribe(subscriberId_1);
                        });
                    }
                    else {
                        $dyn.callFunction(this.RequestClose, this, paramRequestClose_1, requestCloseCallback);
                    }
                }
            };
            /** Override the Form's ObserveFactBoxes since those do not apply to this sub form type */
            Popup.prototype.ObserveFactBoxes = function () { };
            /**
             * Supports backward compatibility where app code has called _close directly from RequestClose overridden function
             * @internal
             */
            Popup.prototype._close = function () {
                // element.dynClose is called from shell.js close function and element is removed from there
                // However, this is done to support backward compatibility where app code has called _close directly from RequestClose overridden function
                // Bug TFS: 3948558
                if (this.element && this.element.dynClose) {
                    $dyn.getFunction(this.element.dynClose)();
                }
                // If a close callback has been set on this form, call it to notify it that the form has closed
                if (this.closeCallback) {
                    $dyn.getFunction(this.closeCallback)();
                }
            };
            Popup.prototype._createOnPopupReceivedEvent = function () {
                var _this = this;
                return {
                    cancel: function () {
                        if ($dyn.value(_this.ReadyState) !== $dyn.ui.ReadyState.aborted) {
                            $dyn.applyFunction(_this.Close, _this);
                        }
                    },
                    popup: this,
                };
            };
            /**
             * Registers events required to transition TakeFocus mode as the user clicks back and forth between the popup and the focus target.
             */
            Popup.prototype._registerTakeFocusTransitioner = function () {
                var _this = this;
                this._focusModeToggler_FlyoutMouseDownEvent = function (event) {
                    // Any explicit click into the popup should cause it to begin taking focus.
                    _this._takeFocus = true;
                    // State is maintained independently to indicate whether or not this code sequence has been hit. This allows the flyout manager to
                    // abort closing the form if the user has simply been transitioning focus mode between the focus target (typically the control hosting
                    // the popup form) and the form.
                    _this.takeFocusToggled = true;
                };
                // mousedown is used in order to be executed before focus handlers, etc., are run.
                this.element.addEventListener("mousedown", this._focusModeToggler_FlyoutMouseDownEvent, true);
                var $focusTarget;
                if (this.FindFocusTarget) {
                    $focusTarget = this.FindFocusTarget();
                }
                if ($focusTarget && $focusTarget.length === 1) {
                    this._focusModeToggler_TargetMousedownEvent = function (event) {
                        // The target has been refocused. Switch back to the original _takeFocus state.
                        _this._takeFocus = false;
                    };
                    this._focusModeToggler_TargetClickEvent = function (event) {
                        _this.takeFocusToggled = false;
                    };
                    this._focusModeToggler_FocusEventTarget = $focusTarget[0];
                    // Note: Two events are registered so that we can correctly hook into the middle of an existing execution sequence.
                    // mousedown is used in order to be executed before focus handlers, etc., are run.
                    this._focusModeToggler_FocusEventTarget.addEventListener("mousedown", this._focusModeToggler_TargetMousedownEvent, true);
                    // Flyout manager's code runs in a click handler on the capture phase.
                    this._focusModeToggler_FocusEventTarget.addEventListener("click", this._focusModeToggler_TargetClickEvent, false);
                }
            };
            Popup.prototype.isElementContainedByPopup = function (element) {
                return $.contains(this.element, element);
            };
            return Popup;
        }($dyn.controls.Form));
        controls.Popup = Popup;
        Popup.prototype.takeFocusOnOpen = true;
        Popup.prototype.highlyResponsive = false;
        Popup.prototype.routeMessagesToParent = false;
        Popup.prototype.popupAborted = false;
        Popup.prototype.TypeName = "Popup";
        Popup.prototype.IsTabbingContainer = true;
        // Popups should always allow a close request to go the server, even if they have invalid data
        // tslint:disable-next-line:no-string-literal
        Popup.prototype["_alwaysAllowClose"] = true;
        $dyn.adapter({ id: "Preview", controlType: "Popup", template: "Preview" });
        $dyn.adapter({ id: "LookupPopup", controlType: "Popup", template: "LookupPopup" });
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=Popup.js.map
